"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var defaultProps = {
    showText: true,
    isOtherOption: false,
    onBlur: function () {
        /* do nothing */
    },
    onClick: function () {
        /* do nothing */
    },
    onChange: function () {
        /* do nothing */
    },
    onKeyDown: function () {
        /* do nothing */
    },
    otherInputValue: '',
    selected: false,
    textAlign: 'left',
    hideCheckbox: false,
    disabled: false,
    smallIcon: false,
};
exports.default = defaultProps;
//# sourceMappingURL=defaultProps.js.map